var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22V27.9423C22 29.0787 21.1044 30 19.9995 30H15",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 36.25V25",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8789 22.985C22.9504 23.253 23.8734 23.253 23.9404 22.9851C24.0074 22.7172 23.193 22.2828 22.1214 22.0149C21.0498 21.747 20.1269 21.747 20.0599 22.0149C19.9929 22.2827 20.8073 22.7171 21.8789 22.985Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.051 21.0139L37.0106 21.0029C37.0048 21.0013 36.9513 21.1855 36.8912 21.4142L36.3086 23.6317C36.2485 23.8605 36.2045 24.0472 36.2104 24.0488L36.2508 24.0599C36.2567 24.0615 36.3102 23.8773 36.3703 23.6486L36.9529 21.4311C37.013 21.2023 37.0569 21.0156 37.051 21.0139Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5658 22.1566L36.1179 22.0326C36.0528 22.0146 35.9698 22.1134 35.9325 22.2534L35.5715 23.6098C35.5342 23.7497 35.5568 23.8778 35.6219 23.8958L36.0698 24.0198C36.1349 24.0378 36.2179 23.939 36.2552 23.799L36.6163 22.4426C36.6535 22.3027 36.6309 22.1746 36.5658 22.1566Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.974 12.8967C18.0458 12.6113 18.3212 12.4419 18.5891 12.5184L38.3774 18.1669C38.7468 18.2723 38.8745 18.7613 38.6092 19.0548L33.3841 24.8361C33.2572 24.9764 33.0688 25.0321 32.8922 24.9818L16.6224 20.3376C16.3545 20.2611 16.1955 19.9677 16.2672 19.6823L17.974 12.8967Z",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20L17.5 16.25",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.d0370392b6b76626685be0a7845297e2.svg";
export { ForwardRef as ReactComponent };